import request from '@/router/axios';

//const urlPrefix = process.env.VUE_APP_ORIG_API
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//查询对公机构账号列表
export function queryPubOrgAccountList(obj) {
  return request({
    url: urlPrefix + '/pub-org-account/list',
    method: 'get',
    params: obj
  })
}

//查询对公机构列表
export function queryPubOrgList(obj) {
  return request({
    url: urlPrefix + '/pub-org-account/pub-org-list',
    method: 'get',
    params: obj
  })
}

/**
 * 根据对公机构ID查询对公机构账号列表
 * @param obj
 */
export function queryPubOrgAccountByOrgId(obj) {
  return request({
    url: urlPrefix + '/pub-org-account/account-list-org-id',
    method: 'get',
    params: obj
  })
}

/**
 * 根据对ID查询对公机构账号信息
 * @param obj
 */
export function queryAccountById(obj) {
  return request({
    url: urlPrefix + '/pub-org-account/' + obj,
    method: 'get'
  })
}
